/* Mood board studio. See sections/dw-mood-studio.liquid */
(() => {
  const root = document.querySelector('[data-dwms]');
  if (!root) return;
  document.body.classList.add('dwms-page');
  const cfg = window.DW_STUDIO || {};
  const $ = (s, el = root) => el.querySelector(s);
  const $$ = (s, el = root) => [...el.querySelectorAll(s)];

  const KEY = 'dw_moodboards_v2';
  const BG_COLORS = ['#ffffff', '#faed17', '#ffd9e4', '#cdf3e3', '#d6ecff', '#e9ddff', '#ffe3c2', '#1b1340'];
  const PENS = ['#111111', '#e52227', '#ff5fa2', '#ff9f1c', '#faed17', '#1fbf5b', '#3fa9ff', '#7b5cff', '#ffffff'];
  const SIZES = [0.006, 0.012, 0.022]; // fraction of board width
  const RATIO = 5 / 4; // board height / width

  // Card styles: frame around the board (see .dwms__frame--<id> in CSS)
  const FRAMES = [
    { id: 'classic', name: 'Classic' },
    { id: 'polaroid', name: 'Polaroid' },
    { id: 'scallop', name: 'Scallop' },
    { id: 'stitch', name: 'Stitched' },
    { id: 'rainbow', name: 'Rainbow' },
    { id: 'sticker', name: 'Sticker' },
  ];
  const FRAME_COLORS = ['#ffffff', '#111111', '#e52227', '#ff5fa2', '#faed17', '#1fbf5b', '#3fa9ff', '#7b5cff'];
  const FONTS = [
    { id: 'none', name: 'Hide', css: '' },
    { id: 'bubbly', name: 'Bubbly', css: '800 {s}px Poppins, system-ui, sans-serif' },
    { id: 'hand', name: 'Handwritten', css: '700 {s}px "Marker Felt", "Comic Sans MS", "Chalkboard SE", cursive' },
    { id: 'classic', name: 'Classic', css: 'italic 700 {s}px Georgia, "Times New Roman", serif' },
  ];

  // Stickers: 24×24 SVG paths. `rule` = fill rule (evenodd punches holes).
  const circ = (cx, cy, r) => `M${cx - r} ${cy}a${r} ${r} 0 1 0 ${2 * r} 0a${r} ${r} 0 1 0 ${-2 * r} 0z`;
  const DECOS = {
    star: { name: 'Star', d: 'M12 2.5l2.9 6 6.6.9-4.8 4.6 1.2 6.5L12 17.4l-5.9 3.1 1.2-6.5L2.5 9.4l6.6-.9z' },
    heart: { name: 'Heart', d: 'M12 21s-7.5-4.6-9.5-9.2C1.2 8.3 3.4 5 6.8 5c2 0 3.6 1.1 5.2 3 1.6-1.9 3.2-3 5.2-3 3.4 0 5.6 3.3 4.3 6.8C19.5 16.4 12 21 12 21z' },
    sparkle: { name: 'Sparkle', d: 'M12 1.5c.6 5 2.5 8.9 10.5 10.5-8 1.6-9.9 5.5-10.5 10.5C11.4 17.5 9.5 13.6 1.5 12c8-1.6 9.9-5.5 10.5-10.5z' },
    bolt: { name: 'Bolt', d: 'M13.5 1.5 4 13.5h6.5L9 22.5l10-12.5h-6.6z' },
    leaf: { name: 'Leaf', d: 'M21 3C10 3 3 9 3 16c0 2 .5 3.5 1.3 4.7C8 13 13 9.5 18 7.5 13.5 10.5 9.5 14.5 6.6 21c1 .4 2.2.6 3.4.6C17 21.6 21 13 21 3z' },
    flower: { name: 'Flower', d: [circ(12, 6, 4), circ(17.7, 10.1, 4), circ(15.5, 16.9, 4), circ(8.5, 16.9, 4), circ(6.3, 10.1, 4), circ(12, 12, 3.5)].join('') },
    cloud: { name: 'Cloud', d: 'M7 19h11a4.5 4.5 0 0 0 .6-9 6 6 0 0 0-11.5-1.5A5 5 0 0 0 7 19z' },
    moon: { name: 'Moon', d: 'M20 14.5A8.5 8.5 0 0 1 9.5 4a8.5 8.5 0 1 0 10.5 10.5z' },
    note: { name: 'Music', d: 'M9 18.5a3 3 0 1 1-2-2.8V4.5l12-2.5v12.5a3 3 0 1 1-2-2.8V6.3l-8 1.7z' },
    crown: { name: 'Crown', d: 'M3 18.5h18l1-11-5.5 4.5L12 4l-4.5 8L2 7.5z' },
    smiley: {
      name: 'Smiley',
      rule: 'evenodd',
      d: circ(12, 12, 10) + circ(8.5, 9.5, 1.5) + circ(15.5, 9.5, 1.5) + 'M7 13.5c1 2.5 3 3.8 5 3.8s4-1.3 5-3.8z',
    },
    rainbow: { name: 'Rainbow', d: 'M2 18a10 10 0 0 1 20 0h-3a7 7 0 0 0-14 0zM6.5 18a5.5 5.5 0 0 1 11 0h-2a3.5 3.5 0 0 0-7 0z' },
  };
  const DECO_COLORS = ['#e52227', '#ff5fa2', '#ff9f1c', '#faed17', '#1fbf5b', '#3fa9ff', '#7b5cff', '#111111', '#ffffff'];
  const isDeco = (h) => h.charAt(0) === '~';
  const decoSvg = (h, c) => {
    const d = DECOS[h.slice(1)];
    return d
      ? `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="${d.d}" fill="${c}"${d.rule ? ` fill-rule="${d.rule}"` : ''}/></svg>`
      : '';
  };

  const money = (c) => '₹' + (c / 100).toLocaleString('en-IN', { minimumFractionDigits: c % 100 ? 2 : 0 });
  const esc = (s) =>
    String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  const shortName = (t) =>
    t.replace(/^Miniature\s+/i, '').replace(/\s*Assorted.*$/i, '').replace(/\s*Building Block.*$/i, '').replace(/\s*\((\d+\s*pcs?|1\s*pc)\)\s*$/i, '').trim() || t;
  const uid = () => Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
  const isDark = (hex) => {
    const n = parseInt(hex.replace('#', ''), 16);
    return ((n >> 16) * 299 + ((n >> 8) & 255) * 587 + (n & 255) * 114) / 1000 < 128;
  };
  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));

  // ── Storage ──────────────────────────────────────────────
  let store = { boards: [] };
  try {
    const s = JSON.parse(localStorage.getItem(KEY) || 'null');
    if (s && Array.isArray(s.boards)) store = s;
  } catch (e) {}
  let saveTimer;
  const persist = () => {
    clearTimeout(saveTimer);
    savedEl.textContent = 'Saving…';
    saveTimer = setTimeout(() => {
      try {
        localStorage.setItem(KEY, JSON.stringify(store));
        savedEl.textContent = 'Saved ✓';
      } catch (e) {
        savedEl.textContent = 'Could not save';
      }
    }, 350);
  };
  const touch = () => {
    if (board) board.updated = Date.now();
    persist();
  };

  const newBoard = (name) => ({
    id: uid(),
    name: name || `Mood board ${store.boards.length + 1}`,
    bg: '#ffffff',
    frame: 'classic',
    fc: '#ffffff',
    font: 'bubbly',
    items: [],
    strokes: [],
    updated: Date.now(),
  });
  const withCard = (b) => Object.assign(b, { frame: b.frame || 'classic', fc: b.fc || '#ffffff', font: b.font || 'bubbly' });

  // ── Products ─────────────────────────────────────────────
  const products = {}; // handle → product
  let productsReady;
  function loadProducts() {
    if (productsReady) return productsReady;
    productsReady = Promise.all(
      (cfg.sources || []).map(async ([handle, label]) => {
        try {
          const res = await fetch(`/collections/${encodeURIComponent(handle)}/products.json?limit=250`);
          const data = await res.json();
          (data.products || []).forEach((p) => {
            if (products[p.handle] || !p.images || !p.images.length) return;
            const v = (p.variants || []).find((x) => x.available);
            if (!v) return;
            const photo = p.images[0].src;
            products[p.handle] = {
              handle: p.handle,
              source: handle,
              name: shortName(p.title),
              title: p.title,
              price: Math.round(parseFloat(v.price) * 100),
              variantId: v.id,
              cutout: (cfg.cutouts || {})[p.handle] || null,
              photo: photo + (photo.includes('?') ? '&' : '?') + 'width=400',
            };
          });
        } catch (e) {}
      })
    );
    return productsReady;
  }
  const imgOf = (p) => (p ? p.cutout || p.photo : '');

  // ── Elements ─────────────────────────────────────────────
  const views = { list: $('[data-view="list"]'), edit: $('[data-view="edit"]'), shared: $('[data-view="shared"]') };
  const boardEl = $('[data-board]');
  const ink = $('[data-ink]');
  const emptyEl = $('[data-empty]');
  const nameEl = $('[data-name]');
  const savedEl = $('[data-saved]');
  const totalEl = $('[data-total]');
  const cartBtn = $('[data-cart]');
  const grid = $('[data-grid]');
  const sheet = $('[data-sheet]');
  const toastEl = $('[data-toast]');

  let board = null; // current board
  let selected = null;
  let mode = 'move';
  let pen = { c: PENS[0], s: SIZES[1] };
  let activeTab = 0;
  let query = '';
  let decoColor = DECO_COLORS[0];
  const STICKER_TAB = () => (cfg.sources || []).length;

  // ── Tracking ──────────────────────────────────────────────
  // Fires DOM events the tracker (assets/mz-tracking.js, EVMAP) turns into beacons.
  // No-op when the tracker is absent, so the studio works standalone.
  const track = (name, detail) => { try { if (window.mzEmit) window.mzEmit('mood:' + name, detail || {}); } catch (e) {} };

  function toast(msg) {
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toast.t);
    toast.t = setTimeout(() => toastEl.classList.remove('is-visible'), 2400);
  }

  function show(view) {
    Object.entries(views).forEach(([k, el]) => (el.hidden = k !== view));
    window.scrollTo({ top: root.getBoundingClientRect().top + window.scrollY - 80, behavior: 'smooth' });
  }

  // ── My boards list ───────────────────────────────────────
  function renderList() {
    const cards = $('[data-cards]');
    const list = store.boards.slice().sort((a, b) => b.updated - a.updated);
    $('[data-list-label]').hidden = !list.length;
    cards.innerHTML = list
      .map((b) => {
        const thumbs = b.items
          .slice(-4)
          .map((it) => {
            const src = (cfg.cutouts || {})[it.h] || (products[it.h] && products[it.h].photo) || '';
            return src ? `<img src="${esc(src)}" alt="" loading="lazy">` : '';
          })
          .join('');
        const date = new Date(b.updated).toLocaleDateString('en-IN', { day: 'numeric', month: 'short' });
        return `<li class="dwms__card" data-id="${b.id}">
          <button type="button" class="dwms__card-open" data-open="${b.id}" style="background:${esc(b.bg)}" aria-label="Open ${esc(b.name)}">
            <span class="dwms__card-thumbs">${thumbs || '<span class="dwms__card-blank">✨</span>'}</span>
          </button>
          <div class="dwms__card-info">
            <p class="dwms__card-name">${esc(b.name)}</p>
            <p class="dwms__card-meta">${b.items.length} toy${b.items.length === 1 ? '' : 's'} · ${date}</p>
          </div>
          <div class="dwms__card-actions">
            <button type="button" data-open="${b.id}">Edit</button>
            <button type="button" data-rename="${b.id}">Rename</button>
            <button type="button" data-delete="${b.id}" class="dwms__danger">Delete</button>
          </div>
        </li>`;
      })
      .join('');
  }

  $('[data-cards]').addEventListener('click', (e) => {
    const open = e.target.closest('[data-open]');
    const ren = e.target.closest('[data-rename]');
    const del = e.target.closest('[data-delete]');
    if (open) return openBoard(open.dataset.open);
    if (ren) {
      const b = store.boards.find((x) => x.id === ren.dataset.rename);
      const card = ren.closest('.dwms__card');
      const nameP = card.querySelector('.dwms__card-name');
      const input = document.createElement('input');
      input.className = 'dwms__rename';
      input.value = b.name;
      input.maxLength = 40;
      nameP.replaceWith(input);
      input.focus();
      input.select();
      const done = () => {
        b.name = input.value.trim() || b.name;
        b.updated = Date.now();
        persist();
        renderList();
      };
      input.addEventListener('blur', done);
      input.addEventListener('keydown', (k) => k.key === 'Enter' && input.blur());
      return;
    }
    if (del) {
      if (del.dataset.confirm !== '1') {
        del.dataset.confirm = '1';
        del.textContent = 'Sure?';
        setTimeout(() => {
          if (del.isConnected) {
            del.dataset.confirm = '';
            del.textContent = 'Delete';
          }
        }, 2500);
        return;
      }
      store.boards = store.boards.filter((x) => x.id !== del.dataset.delete);
      persist();
      renderList();
      toast('Board deleted');
    }
  });

  $('[data-new]').addEventListener('click', () => {
    const b = newBoard();
    store.boards.push(b);
    persist();
    track('board-new', { count: store.boards.length });
    openBoard(b.id);
  });

  // ── Editor ───────────────────────────────────────────────
  function openBoard(id) {
    board = store.boards.find((b) => b.id === id);
    if (!board) return;
    track('board-open', { count: board.items.length });
    withCard(board);
    selected = null;
    nameEl.value = board.name;
    savedEl.textContent = 'Saved ✓';
    setMode('move');
    show('edit');
    applyBg();
    applyCard();
    loadProducts().then(() => {
      renderTabs();
      renderGrid();
      renderItems();
    });
    renderItems();
    requestAnimationFrame(sizeInk);
  }

  nameEl.addEventListener('input', () => {
    board.name = nameEl.value.slice(0, 40) || 'Untitled board';
    applyCard();
    touch();
  });
  $('[data-back]').addEventListener('click', () => {
    board = null;
    renderList();
    show('list');
  });

  function applyBg() {
    boardEl.style.background = board.bg;
    boardEl.classList.toggle('is-dark', isDark(board.bg));
    $$('[data-bgs] button').forEach((b) => b.setAttribute('aria-checked', String(b.dataset.bg === board.bg)));
    $('[data-bg-custom]').value = board.bg.length === 7 ? board.bg : '#ffffff';
  }

  // Card style: frame, frame colour, name on the card
  function paintCard(frameEl, titleEl, b) {
    FRAMES.forEach((f) => frameEl.classList.toggle('dwms__frame--' + f.id, f.id === b.frame));
    frameEl.style.setProperty('--frame', b.fc);
    frameEl.style.setProperty('--frame-ink', isDark(b.fc) ? '#fff' : '#111');
    const font = FONTS.find((f) => f.id === b.font) || FONTS[1];
    titleEl.hidden = font.id === 'none' || !b.name;
    titleEl.textContent = b.name;
    titleEl.style.font = font.css ? font.css.replace('{s}', 20) : '';
  }
  function applyCard() {
    paintCard($('[data-frame]'), $('[data-frame-title]'), board);
    $$('[data-frame-id]').forEach((x) => x.setAttribute('aria-checked', String(x.dataset.frameId === board.frame)));
    $$('[data-frame-color]').forEach((x) => x.setAttribute('aria-checked', String(x.dataset.frameColor === board.fc)));
    $$('[data-font]').forEach((x) => x.setAttribute('aria-checked', String(x.dataset.font === board.font)));
    requestAnimationFrame(sizeInk);
  }
  $('[data-frames]').innerHTML = FRAMES.map(
    (f) => `<button type="button" role="radio" data-frame-id="${f.id}" aria-checked="false">
      <span class="dwms__frame-chip dwms__frame-chip--${f.id}"></span><span>${f.name}</span></button>`
  ).join('');
  $('[data-frames]').addEventListener('click', (e) => {
    const b = e.target.closest('[data-frame-id]');
    if (!b) return;
    board.frame = b.dataset.frameId;
    applyCard();
    touch();
  });
  $('[data-frame-colors]').innerHTML = FRAME_COLORS.map(
    (c) => `<button type="button" role="radio" data-frame-color="${c}" style="background:${c}" aria-label="Frame colour ${c}"></button>`
  ).join('');
  $('[data-frame-colors]').addEventListener('click', (e) => {
    const b = e.target.closest('[data-frame-color]');
    if (!b) return;
    board.fc = b.dataset.frameColor;
    applyCard();
    touch();
  });
  $('[data-fonts]').innerHTML = FONTS.map(
    (f) => `<button type="button" role="radio" data-font="${f.id}" aria-checked="false"${f.css ? ` style="font:${f.css.replace('{s}', 14)}"` : ''}>${f.name}</button>`
  ).join('');
  $('[data-fonts]').addEventListener('click', (e) => {
    const b = e.target.closest('[data-font]');
    if (!b) return;
    board.font = b.dataset.font;
    applyCard();
    touch();
  });

  // Items
  function place(el, it) {
    el.style.left = it.x * 100 + '%';
    el.style.top = it.y * 100 + '%';
    el.style.width = it.w * 100 + '%';
    el.style.zIndex = it.z;
    el.style.transform = `translate(-50%, -50%) rotate(${it.r}deg) scaleX(${it.f})`;
  }

  function itemHtml(it) {
    if (isDeco(it.h)) {
      const svg = decoSvg(it.h, it.c || '#e52227');
      return svg ? `<div class="dwms__item is-deco${selected === it.uid ? ' is-selected' : ''}" data-uid="${it.uid}">${svg}</div>` : '';
    }
    const p = products[it.h];
    const src = (cfg.cutouts || {})[it.h] || (p && p.photo);
    if (!src) return '';
    const photo = !(cfg.cutouts || {})[it.h];
    return `<div class="dwms__item${photo ? ' is-photo' : ''}${selected === it.uid ? ' is-selected' : ''}" data-uid="${it.uid}">
      <img src="${esc(src)}" alt="" draggable="false" crossorigin="anonymous"></div>`;
  }

  function renderItems(targetBoard = boardEl, data = board, readOnly = false) {
    $$('.dwms__item', targetBoard).forEach((n) => n.remove());
    const frag = document.createDocumentFragment();
    data.items.forEach((it) => {
      const tmp = document.createElement('div');
      tmp.innerHTML = itemHtml(it);
      const el = tmp.firstElementChild;
      if (!el) return;
      place(el, it);
      frag.appendChild(el);
    });
    targetBoard.insertBefore(frag, targetBoard.querySelector('canvas'));
    if (!readOnly) {
      emptyEl.hidden = data.items.length > 0;
      updateTotal();
    }
  }

  function select(id) {
    selected = id;
    const it = id && board && board.items.find((i) => i.uid === id);
    if (it && isDeco(it.h)) {
      decoColor = it.c;
      paintDecoSwatches();
    }
    $$('.dwms__item', boardEl).forEach((n) => n.classList.toggle('is-selected', n.dataset.uid === id));
    $('[data-tools-move]').classList.toggle('is-active', !!id);
  }

  function addItem(handle) {
    const deco = isDeco(handle);
    track('item-add', { handle: handle, value: deco ? 'sticker' : 'product', count: board.items.length + 1 });
    const n = board.items.length;
    const z = board.items.reduce((m, i) => Math.max(m, i.z), 0) + 1;
    const it = {
      uid: uid(),
      h: handle,
      x: clamp(0.5 + ((n % 5) - 2) * 0.09, 0.1, 0.9),
      y: clamp(0.52 + ((Math.floor(n / 5) % 3) - 1) * 0.12, 0.12, 0.88),
      w: deco ? 0.16 : 0.28,
      r: ((n % 3) - 1) * 6,
      f: 1,
      z,
    };
    if (deco) it.c = decoColor;
    board.items.push(it);
    selected = it.uid;
    if (mode !== 'move') setMode('move');
    renderItems();
    select(it.uid);
    touch();
    if (window.matchMedia('(max-width: 989px)').matches) {
      toast(`Added ${deco ? DECOS[handle.slice(1)].name.toLowerCase() + ' sticker' : products[handle] ? products[handle].name : 'toy'} ✨`);
    }
  }

  function updateTotal() {
    let total = 0;
    let n = 0;
    board.items.forEach((it) => {
      const p = products[it.h];
      if (p) {
        total += p.price;
        n++;
      }
    });
    totalEl.textContent = n ? `${n} toy${n > 1 ? 's' : ''} · ${money(total)}` : 'No toys on your board yet';
    cartBtn.disabled = !n;
  }

  // Tools
  $('[data-tools-move]').addEventListener('click', (e) => {
    const t = e.target.closest('[data-tool]');
    const it = selected && board.items.find((i) => i.uid === selected);
    if (!t || !it) return;
    const tool = t.dataset.tool;
    if (tool === 'smaller') it.w = Math.max(0.06, it.w * 0.85);
    if (tool === 'bigger') it.w = Math.min(0.95, it.w * 1.18);
    if (tool === 'left') it.r -= 15;
    if (tool === 'right') it.r += 15;
    if (tool === 'flip') it.f *= -1;
    if (tool === 'front') it.z = board.items.reduce((m, i) => Math.max(m, i.z), 0) + 1;
    if (tool === 'delete') {
      board.items = board.items.filter((i) => i !== it);
      selected = null;
    }
    renderItems();
    select(selected);
    touch();
  });

  function setMode(m) {
    mode = m;
    $$('[data-mode]').forEach((b) => b.setAttribute('aria-selected', String(b.dataset.mode === m)));
    $('[data-tools-move]').hidden = m !== 'move';
    $('[data-tools-draw]').hidden = m !== 'draw';
    boardEl.classList.toggle('is-drawing', m === 'draw');
    if (m === 'draw') select(null);
  }
  $$('[data-mode]').forEach((b) => b.addEventListener('click', () => setMode(b.dataset.mode)));

  // Swatches
  $('[data-bgs]').innerHTML = BG_COLORS.map(
    (c) => `<button type="button" role="radio" data-bg="${c}" style="background:${c}" aria-label="Board colour ${c}"></button>`
  ).join('');
  $('[data-bgs]').addEventListener('click', (e) => {
    const b = e.target.closest('[data-bg]');
    if (!b) return;
    board.bg = b.dataset.bg;
    applyBg();
    touch();
  });
  $('[data-bg-custom]').addEventListener('input', (e) => {
    board.bg = e.target.value;
    applyBg();
    touch();
  });
  $('[data-pens]').innerHTML = PENS.map(
    (c, i) => `<button type="button" role="radio" data-pen="${c}" aria-checked="${i === 0}" style="background:${c}" aria-label="Pen ${c}"></button>`
  ).join('');
  $('[data-pens]').addEventListener('click', (e) => {
    const b = e.target.closest('[data-pen]');
    if (!b) return;
    pen.c = b.dataset.pen;
    $$('[data-pen]').forEach((x) => x.setAttribute('aria-checked', String(x === b)));
  });
  $('[data-sizes]').innerHTML = SIZES.map(
    (s, i) =>
      `<button type="button" role="radio" data-size="${s}" aria-checked="${i === 1}" aria-label="Pen size ${i + 1}"><span style="width:${6 + i * 6}px;height:${6 + i * 6}px"></span></button>`
  ).join('');
  $('[data-sizes]').addEventListener('click', (e) => {
    const b = e.target.closest('[data-size]');
    if (!b) return;
    pen.s = parseFloat(b.dataset.size);
    $$('[data-size]').forEach((x) => x.setAttribute('aria-checked', String(x === b)));
  });
  $('[data-undo]').addEventListener('click', () => {
    board.strokes.pop();
    drawInk();
    touch();
  });
  $('[data-clear-ink]').addEventListener('click', (e) => {
    const btn = e.currentTarget;
    if (!board.strokes.length) return;
    if (btn.dataset.confirm !== '1') {
      btn.dataset.confirm = '1';
      btn.textContent = 'Sure?';
      setTimeout(() => {
        btn.dataset.confirm = '';
        btn.textContent = 'Clear doodles';
      }, 2500);
      return;
    }
    btn.dataset.confirm = '';
    btn.textContent = 'Clear doodles';
    board.strokes = [];
    drawInk();
    touch();
  });

  // ── Doodles (canvas) ─────────────────────────────────────
  function sizeCanvas(cv) {
    const r = cv.parentElement.getBoundingClientRect();
    const dpr = window.devicePixelRatio || 1;
    cv.width = Math.round(r.width * dpr);
    cv.height = Math.round(r.height * dpr);
  }
  function sizeInk() {
    if (!board) return;
    sizeCanvas(ink);
    drawInk();
  }
  function paintStrokes(ctx, strokes, W, H) {
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
    strokes.forEach((s) => {
      const pts = s.p;
      ctx.strokeStyle = s.c;
      ctx.fillStyle = s.c;
      ctx.lineWidth = s.s * W;
      if (pts.length < 4) {
        ctx.beginPath();
        ctx.arc(pts[0] * W, pts[1] * H, (s.s * W) / 2, 0, Math.PI * 2);
        ctx.fill();
        return;
      }
      ctx.beginPath();
      ctx.moveTo(pts[0] * W, pts[1] * H);
      for (let i = 2; i < pts.length; i += 2) ctx.lineTo(pts[i] * W, pts[i + 1] * H);
      ctx.stroke();
    });
  }
  function drawInk(cv = ink, data = board) {
    const ctx = cv.getContext('2d');
    ctx.clearRect(0, 0, cv.width, cv.height);
    paintStrokes(ctx, data.strokes, cv.width, cv.height);
  }
  window.addEventListener('resize', () => {
    sizeInk();
    if (!views.shared.hidden && sharedBoard) {
      sizeCanvas($('[data-shared-ink]'));
      drawInk($('[data-shared-ink]'), sharedBoard);
    }
  });

  let stroke = null;
  ink.addEventListener('pointerdown', (e) => {
    if (mode !== 'draw') return;
    e.preventDefault();
    ink.setPointerCapture(e.pointerId);
    const r = ink.getBoundingClientRect();
    stroke = { c: pen.c, s: pen.s, p: [+((e.clientX - r.left) / r.width).toFixed(4), +((e.clientY - r.top) / r.height).toFixed(4)] };
    board.strokes.push(stroke);
    drawInk();
  });
  ink.addEventListener('pointermove', (e) => {
    if (!stroke) return;
    const r = ink.getBoundingClientRect();
    const x = +((e.clientX - r.left) / r.width).toFixed(4);
    const y = +((e.clientY - r.top) / r.height).toFixed(4);
    const lx = stroke.p[stroke.p.length - 2];
    const ly = stroke.p[stroke.p.length - 1];
    if (Math.hypot(x - lx, y - ly) < 0.004) return; // thin out points
    stroke.p.push(x, y);
    drawInk();
  });
  const endStroke = () => {
    if (!stroke) return;
    stroke = null;
    touch();
  };
  ink.addEventListener('pointerup', endStroke);
  ink.addEventListener('pointercancel', endStroke);

  // ── Arrange gestures: drag, pinch-resize, twist-rotate ───
  const pointers = new Map();
  let gesture = null;
  boardEl.addEventListener('pointerdown', (e) => {
    if (mode !== 'move') return;
    const el = e.target.closest('.dwms__item');
    pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
    boardEl.setPointerCapture(e.pointerId);
    if (pointers.size === 1) {
      if (!el) return select(null), (gesture = null);
      select(el.dataset.uid);
      const it = board.items.find((i) => i.uid === el.dataset.uid);
      gesture = { mode: 'drag', it, el, sx: e.clientX, sy: e.clientY, ox: it.x, oy: it.y };
    } else if (pointers.size === 2 && selected) {
      const it = board.items.find((i) => i.uid === selected);
      const el2 = boardEl.querySelector(`[data-uid="${selected}"]`);
      const [a, b] = [...pointers.values()];
      gesture = { mode: 'pinch', it, el: el2, d0: Math.hypot(b.x - a.x, b.y - a.y), a0: Math.atan2(b.y - a.y, b.x - a.x), w0: it.w, r0: it.r };
    }
  });
  boardEl.addEventListener('pointermove', (e) => {
    if (!pointers.has(e.pointerId) || !gesture) return;
    pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
    const r = boardEl.getBoundingClientRect();
    const g = gesture;
    if (g.mode === 'drag' && pointers.size === 1) {
      g.it.x = clamp(g.ox + (e.clientX - g.sx) / r.width, 0, 1);
      g.it.y = clamp(g.oy + (e.clientY - g.sy) / r.height, 0, 1);
    } else if (g.mode === 'pinch' && pointers.size === 2) {
      const [a, b] = [...pointers.values()];
      g.it.w = clamp(g.w0 * (Math.hypot(b.x - a.x, b.y - a.y) / g.d0), 0.06, 0.95);
      g.it.r = g.r0 + ((Math.atan2(b.y - a.y, b.x - a.x) - g.a0) * 180) / Math.PI;
    }
    place(g.el, g.it);
  });
  const endPointer = (e) => {
    if (!pointers.has(e.pointerId)) return;
    pointers.delete(e.pointerId);
    if (gesture) touch();
    if (!pointers.size) gesture = null;
    else if (gesture && gesture.mode === 'pinch') {
      const [p] = [...pointers.values()];
      gesture = { mode: 'drag', it: gesture.it, el: gesture.el, sx: p.x, sy: p.y, ox: gesture.it.x, oy: gesture.it.y };
    }
  };
  boardEl.addEventListener('pointerup', endPointer);
  boardEl.addEventListener('pointercancel', endPointer);
  // Desktop: mouse wheel over the selected toy resizes it
  boardEl.addEventListener(
    'wheel',
    (e) => {
      const el = e.target.closest('.dwms__item');
      if (!el || mode !== 'move') return;
      e.preventDefault();
      const it = board.items.find((i) => i.uid === el.dataset.uid);
      select(it.uid);
      it.w = clamp(it.w * (e.deltaY < 0 ? 1.08 : 0.92), 0.06, 0.95);
      place(el, it);
      touch();
    },
    { passive: false }
  );

  // ── Library ──────────────────────────────────────────────
  const TAB_ICONS = ['🧱', '👻', '🐱'];
  function renderTabs() {
    const tabs = (cfg.sources || []).map((s, i) => [s[1], TAB_ICONS[i] || '🎁']).concat([['Stickers', '⭐']]);
    $('[data-tabs]').innerHTML = tabs
      .map(
        ([label, ico], i) =>
          `<button type="button" role="tab" data-tab="${i}" aria-selected="${i === activeTab}" aria-label="${esc(label)}">` +
          `<span class="dwms__tab-ico" aria-hidden="true">${ico}</span><span class="dwms__tab-txt">${esc(label)}</span></button>`
      )
      .join('');
  }
  function paintDecoSwatches() {
    $$('[data-deco]').forEach((b) => b.setAttribute('aria-checked', String(b.dataset.deco === decoColor)));
    $('[data-deco-custom]').value = /^#[0-9a-f]{6}$/i.test(decoColor) ? decoColor : '#e52227';
    $$('[data-add-deco] path').forEach((p) => p.setAttribute('fill', decoColor));
  }
  function setDecoColor(c) {
    decoColor = c;
    paintDecoSwatches();
    const it = selected && board.items.find((i) => i.uid === selected);
    if (it && isDeco(it.h)) {
      it.c = c;
      renderItems();
      select(it.uid);
      touch();
    }
  }
  $('[data-deco-swatches]').innerHTML = DECO_COLORS.map(
    (c) => `<button type="button" role="radio" data-deco="${c}" style="background:${c}" aria-label="Sticker colour ${c}"></button>`
  ).join('');
  $('[data-deco-swatches]').addEventListener('click', (e) => {
    const b = e.target.closest('[data-deco]');
    if (b) setDecoColor(b.dataset.deco);
  });
  $('[data-deco-custom]').addEventListener('input', (e) => setDecoColor(e.target.value));
  $('[data-tabs]').addEventListener('click', (e) => {
    const b = e.target.closest('[data-tab]');
    if (!b) return;
    activeTab = Number(b.dataset.tab);
    renderTabs();
    renderGrid();
  });
  $('[data-search]').addEventListener('input', (e) => {
    query = e.target.value.trim().toLowerCase();
    renderGrid();
  });
  function renderGrid() {
    const stickers = activeTab === STICKER_TAB();
    $('[data-deco-colors]').hidden = !stickers;
    $('[data-search]').hidden = stickers;
    if (stickers) {
      grid.innerHTML = Object.entries(DECOS)
        .map(
          ([id, d]) => `<button type="button" class="dwms__toy dwms__toy--deco" data-add-deco="~${id}" aria-label="Add ${d.name} sticker">
            <span class="dwms__toy-img">${decoSvg('~' + id, decoColor)}</span>
            <span class="dwms__toy-name">${d.name}</span>
          </button>`
        )
        .join('');
      paintDecoSwatches();
      return;
    }
    const src = (cfg.sources || [])[activeTab];
    const list = Object.values(products).filter(
      (p) => (query ? true : p.source === (src && src[0])) && (!query || p.title.toLowerCase().includes(query))
    );
    grid.innerHTML = list.length
      ? list
          .map(
            (p) => `<button type="button" class="dwms__toy" data-add="${esc(p.handle)}" aria-label="Add ${esc(p.name)}">
              <span class="dwms__toy-img${p.cutout ? '' : ' is-photo'}"><img src="${esc(imgOf(p))}" alt="" loading="lazy"></span>
              <span class="dwms__toy-name">${esc(p.name)}</span>
              <span class="dwms__toy-price">${money(p.price)}</span>
            </button>`
          )
          .join('')
      : `<p class="dwms__loading">${query ? 'No toys match that search.' : 'No toys here right now.'}</p>`;
  }
  grid.addEventListener('click', (e) => {
    const b = e.target.closest('[data-add], [data-add-deco]');
    if (b && board) addItem(b.dataset.add || b.dataset.addDeco);
  });

  // ── Cart ─────────────────────────────────────────────────
  async function addToCart(items, attributes) {
    const counts = {};
    items.forEach((it) => {
      const p = products[it.h];
      if (p) counts[p.variantId] = (counts[p.variantId] || 0) + 1;
    });
    const gift = !!(attributes && attributes['Gift mood board']);
    /* Stamped on every line so the order itself says where it came from — Shopify Flow
       tags on these, and they show on the order, invoice and packing slip. */
    const props = { _added_from: 'mood-board', _mood_board: (board && board.name) || '', _mood_gift: gift ? 'yes' : 'no' };
    const lines = Object.entries(counts).map(([id, quantity]) => ({ id: Number(id), quantity, properties: props }));
    if (!lines.length) throw new Error('These toys are not available right now');
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: lines, sections: 'cart-drawer,cart-icon-bubble', sections_url: location.pathname }),
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || 'Could not add to cart');
    track('cart-add', { count: lines.reduce((n, l) => n + l.quantity, 0), value: lines.length, from: (attributes && attributes['Gift mood board']) ? 'gift' : 'board' });
    const attrs = Object.assign({ 'Mood board': (board && board.name) || 'Mood board' }, attributes || {});
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs }),
    }).catch(() => {});
    const bubble = document.getElementById('cart-icon-bubble');
    if (bubble && data.sections && data.sections['cart-icon-bubble']) {
      const inner = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
      if (inner) bubble.innerHTML = inner.innerHTML;
    }
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
      drawer.classList.remove('is-empty');
      drawer.renderContents({ id: lines[0].id, sections: data.sections });
    }
    return lines.reduce((a, l) => a + l.quantity, 0);
  }
  async function withBusy(btn, fn) {
    const label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Please wait…';
    try {
      await fn();
    } catch (e) {
      toast(e.message || 'Something went wrong');
    } finally {
      btn.disabled = false;
      btn.textContent = label;
    }
  }
  cartBtn.addEventListener('click', () =>
    withBusy(cartBtn, async () => {
      const n = await addToCart(board.items);
      toast(`${n} toy${n > 1 ? 's' : ''} added to cart ✓`);
    })
  );

  // ── Share link encoding ──────────────────────────────────
  const b64u = (bytes) => btoa(String.fromCharCode(...bytes)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  const unb64u = (s) => Uint8Array.from(atob(s.replace(/-/g, '+').replace(/_/g, '/')), (c) => c.charCodeAt(0));
  const pack = (b) => ({
    n: b.name,
    b: b.bg,
    fr: [b.frame, b.fc, b.font],
    i: b.items.map((it) => {
      const a = [it.h, +it.x.toFixed(3), +it.y.toFixed(3), +it.w.toFixed(3), Math.round(it.r), it.f, it.z];
      if (it.c) a.push(it.c);
      return a;
    }),
    s: b.strokes.map((s) => [s.c, s.s, s.p.map((v) => +v.toFixed(3))]),
  });
  const unpack = (o) => ({
    id: uid(),
    name: String(o.n || 'Shared mood board').slice(0, 40),
    bg: /^#[0-9a-f]{3,8}$/i.test(o.b) ? o.b : '#ffffff',
    frame: FRAMES.some((f) => o.fr && f.id === o.fr[0]) ? o.fr[0] : 'classic',
    fc: o.fr && /^#[0-9a-f]{3,8}$/i.test(o.fr[1]) ? o.fr[1] : '#ffffff',
    font: FONTS.some((f) => o.fr && f.id === o.fr[2]) ? o.fr[2] : 'bubbly',
    items: (o.i || [])
      .map((a) => {
        const it = { uid: uid(), h: String(a[0]), x: +a[1], y: +a[2], w: +a[3], r: +a[4], f: a[5] === -1 ? -1 : 1, z: +a[6] || 1 };
        if (isDeco(it.h)) it.c = /^#[0-9a-f]{3,8}$/i.test(a[7]) ? a[7] : '#e52227';
        return it;
      })
      .filter((it) => !isDeco(it.h) || DECOS[it.h.slice(1)]),
    strokes: (o.s || []).map((a) => ({ c: String(a[0]), s: +a[1], p: (a[2] || []).map(Number) })),
    updated: Date.now(),
  });
  async function encodeBoard(b) {
    const json = new TextEncoder().encode(JSON.stringify(pack(b)));
    if (window.CompressionStream) {
      const buf = await new Response(new Blob([json]).stream().pipeThrough(new CompressionStream('deflate-raw'))).arrayBuffer();
      return 'z' + b64u(new Uint8Array(buf));
    }
    return 'j' + b64u(json);
  }
  async function decodeBoard(code) {
    const bytes = unb64u(code.slice(1));
    let json = bytes;
    if (code[0] === 'z') {
      json = new Uint8Array(await new Response(new Blob([bytes]).stream().pipeThrough(new DecompressionStream('deflate-raw'))).arrayBuffer());
    }
    return unpack(JSON.parse(new TextDecoder().decode(json)));
  }
  async function shareUrl(b) {
    const base = new URL(cfg.pageUrl || location.pathname + location.search, location.origin);
    return base.href + '#mb=' + (await encodeBoard(b));
  }

  // ── Picture ──────────────────────────────────────────────
  const loadImg = (src) =>
    new Promise((res, rej) => {
      const i = new Image();
      i.crossOrigin = 'anonymous';
      i.onload = () => res(i);
      i.onerror = rej;
      i.src = src;
    });
  function roundRect(c, x, y, w, h, r) {
    c.beginPath();
    c.moveTo(x + r, y);
    c.arcTo(x + w, y, x + w, y + h, r);
    c.arcTo(x + w, y + h, x, y + h, r);
    c.arcTo(x, y + h, x, y, r);
    c.arcTo(x, y, x + w, y, r);
    c.closePath();
  }
  // Frame padding (px) around the 1080×1350 board, per card style: [sides, top, bottom]
  const FRAME_PAD = { classic: [40, 40, 40], polaroid: [52, 52, 190], scallop: [56, 56, 56], stitch: [48, 48, 48], rainbow: [40, 40, 40], sticker: [44, 44, 44] };
  async function renderPicture(b) {
    withCard(b);
    const W = 1080;
    const H = Math.round(W * RATIO);
    const [P, PT, PB] = FRAME_PAD[b.frame] || FRAME_PAD.classic;
    const CW = W + 2 * P;
    const CH = H + PT + PB;
    const cv = document.createElement('canvas');
    cv.width = CW;
    cv.height = CH;
    const c = cv.getContext('2d');
    const frameInk = isDark(b.fc) ? '#fff' : '#111';

    // Frame
    if (b.frame === 'classic') {
      c.fillStyle = '#111';
      roundRect(c, 0, 0, CW, CH, 64);
      c.fill();
      c.fillStyle = b.fc;
      roundRect(c, 12, 12, CW - 24, CH - 24, 54);
      c.fill();
    } else if (b.frame === 'rainbow') {
      const g = c.createLinearGradient(0, 0, CW, CH);
      ['#e52227', '#ff9f1c', '#faed17', '#1fbf5b', '#3fa9ff', '#7b5cff'].forEach((col, i, arr) => g.addColorStop(i / (arr.length - 1), col));
      c.fillStyle = g;
      roundRect(c, 0, 0, CW, CH, 64);
      c.fill();
    } else if (b.frame === 'scallop') {
      const r = 28;
      c.fillStyle = b.fc;
      c.fillRect(r, r, CW - 2 * r, CH - 2 * r);
      const dot = (x, y) => {
        c.beginPath();
        c.arc(x, y, r, 0, Math.PI * 2);
        c.fill();
      };
      const nx = Math.round((CW - 2 * r) / (1.6 * r));
      const ny = Math.round((CH - 2 * r) / (1.6 * r));
      for (let i = 0; i <= nx; i++) {
        const x = r + ((CW - 2 * r) * i) / nx;
        dot(x, r);
        dot(x, CH - r);
      }
      for (let i = 0; i <= ny; i++) {
        const y = r + ((CH - 2 * r) * i) / ny;
        dot(r, y);
        dot(CW - r, y);
      }
    } else {
      c.fillStyle = b.fc;
      roundRect(c, 0, 0, CW, CH, b.frame === 'polaroid' ? 18 : 60);
      c.fill();
      if (b.frame === 'stitch') {
        c.save();
        c.strokeStyle = frameInk;
        c.globalAlpha = 0.55;
        c.lineWidth = 5;
        c.setLineDash([22, 14]);
        roundRect(c, P / 2, P / 2, CW - P, CH - P, 48);
        c.stroke();
        c.restore();
      }
    }

    // Board
    c.save();
    roundRect(c, P, PT, W, H, b.frame === 'polaroid' ? 6 : 40);
    c.clip();
    c.translate(P, PT);
    c.fillStyle = b.bg;
    c.fillRect(0, 0, W, H);
    for (const it of b.items.slice().sort((a, z) => a.z - z.z)) {
      const dw = it.w * W;
      if (isDeco(it.h)) {
        const d = DECOS[it.h.slice(1)];
        if (!d) continue;
        c.save();
        c.translate(it.x * W, it.y * H);
        c.rotate((it.r * Math.PI) / 180);
        c.scale((it.f * dw) / 24, dw / 24);
        c.translate(-12, -12);
        c.fillStyle = it.c || '#e52227';
        c.fill(new Path2D(d.d), d.rule || 'nonzero');
        c.restore();
        continue;
      }
      const p = products[it.h];
      const src = (cfg.cutouts || {})[it.h] || (p && p.photo);
      if (!src) continue;
      try {
        const img = await loadImg(src);
        const dh = dw * (img.naturalHeight / img.naturalWidth);
        c.save();
        c.translate(it.x * W, it.y * H);
        c.rotate((it.r * Math.PI) / 180);
        c.scale(it.f, 1);
        if (!(cfg.cutouts || {})[it.h]) {
          c.fillStyle = '#fff';
          c.fillRect(-dw / 2 - 10, -dh / 2 - 10, dw + 20, dh + 20);
        }
        c.drawImage(img, -dw / 2, -dh / 2, dw, dh);
        c.restore();
      } catch (e) {}
    }
    paintStrokes(c, b.strokes, W, H);
    c.restore();

    // Name on the card
    const font = FONTS.find((f) => f.id === b.font) || FONTS[1];
    if (font.css && b.name) {
      c.textAlign = 'center';
      c.textBaseline = 'middle';
      if (b.frame === 'polaroid') {
        c.fillStyle = frameInk;
        c.font = font.css.replace('{s}', 72);
        c.fillText(b.name, CW / 2, PT + H + PB / 2, CW - 120);
      } else {
        c.font = font.css.replace('{s}', 58);
        const tw = Math.min(c.measureText(b.name).width, W - 160) + 64;
        c.fillStyle = b.fc;
        roundRect(c, (CW - tw) / 2, PT + 30, tw, 92, 46);
        c.fill();
        c.fillStyle = frameInk;
        c.fillText(b.name, CW / 2, PT + 78, W - 160);
      }
    }
    c.globalAlpha = 0.7;
    c.textAlign = 'right';
    c.textBaseline = 'alphabetic';
    c.fillStyle = isDark(b.bg) ? '#fff' : '#111';
    c.font = '600 28px Poppins, system-ui, sans-serif';
    c.fillText('made at dawbu.com', P + W - 28, PT + H - 28);
    return new Promise((r) => cv.toBlob(r, 'image/png'));
  }
  async function pictureFile(b) {
    const blob = await renderPicture(b);
    return new File([blob], (b.name || 'mood-board').replace(/[^\w-]+/g, '-').toLowerCase() + '.png', { type: 'image/png' });
  }
  function download(file) {
    const a = document.createElement('a');
    a.href = URL.createObjectURL(file);
    a.download = file.name;
    document.body.appendChild(a);
    a.click();
    setTimeout(() => (URL.revokeObjectURL(a.href), a.remove()), 1000);
  }
  $('[data-picture]').addEventListener('click', (e) =>
    withBusy(e.currentTarget, async () => {
      const file = await pictureFile(board);
      track('picture-save', { count: board.items.length });
      if (navigator.canShare && navigator.canShare({ files: [file] }) && matchMedia('(pointer: coarse)').matches) {
        await navigator.share({ files: [file], title: board.name }).catch(() => {});
      } else {
        download(file);
        toast('Picture saved ✓');
      }
    })
  );

  // ── Share sheet ──────────────────────────────────────────
  const openSheet = async () => {
    sheet.hidden = false;
    requestAnimationFrame(() => sheet.classList.add('is-open'));
    const url = await shareUrl(board);
    const text = `I made a mood board on Dawbu 💖 "${board.name}" — would you gift me these toys? ${url}`;
    $('[data-ask-whatsapp]').href = 'https://wa.me/?text=' + encodeURIComponent(text);
  };
  const closeSheet = () => {
    sheet.classList.remove('is-open');
    setTimeout(() => (sheet.hidden = true), 200);
  };
  $('[data-share]').addEventListener('click', () => {
    if (!board.items.length) return toast('Add some toys to your board first ✨');
    track('share-open', { count: board.items.length });
    openSheet();
  });
  $('[data-sheet-close]').addEventListener('click', closeSheet);
  sheet.addEventListener('click', (e) => e.target === sheet && closeSheet());
  document.addEventListener('keydown', (e) => e.key === 'Escape' && !sheet.hidden && closeSheet());

  async function copy(text) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (e) {
      const t = document.createElement('textarea');
      t.value = text;
      document.body.appendChild(t);
      t.select();
      const ok = document.execCommand('copy');
      t.remove();
      return ok;
    }
  }

  $('[data-gift-cart]').addEventListener('click', (e) =>
    withBusy(e.currentTarget, async () => {
      const url = await shareUrl(board);
      const n = await addToCart(board.items, { 'Gift mood board': board.name, 'Gift mood board link': url });
      toast(`${n} toys added as a gift 🎁`);
    })
  );
  $('[data-gift-send]').addEventListener('click', (e) =>
    withBusy(e.currentTarget, async () => {
      const url = await shareUrl(board);
      const file = await pictureFile(board);
      const text = `I made you a mood board on Dawbu 🎁 "${board.name}" — these toys are on their way to you!`;
      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share({ files: [file], title: board.name, text: text + ' ' + url }).catch(() => {});
      } else if (navigator.share) {
        await navigator.share({ title: board.name, text, url }).catch(() => {});
      } else {
        download(file);
        (await copy(text + ' ' + url)) && toast('Picture saved and message copied ✓');
      }
    })
  );
  $('[data-ask-share]').addEventListener('click', (e) =>
    withBusy(e.currentTarget, async () => {
      const url = await shareUrl(board);
      const text = `I made a mood board on Dawbu 💖 "${board.name}" — would you gift me these toys?`;
      track('ask-share', { count: board.items.length });
      if (navigator.share) await navigator.share({ title: board.name, text, url }).catch(() => {});
      else (await copy(text + ' ' + url)) && toast('Link copied ✓');
    })
  );
  $('[data-ask-copy]').addEventListener('click', async () => {
    const url = await shareUrl(board);
    toast((await copy(url)) ? 'Link copied ✓' : 'Could not copy the link');
  });

  // ── Shared board (someone opened a link) ─────────────────
  let sharedBoard = null;
  async function openShared(code) {
    try {
      sharedBoard = await decodeBoard(code);
    } catch (e) {
      toast('That mood board link looks broken');
      return false;
    }
    show('shared');
    $('[data-shared-name]').textContent = sharedBoard.name;
    const sb = $('[data-shared-board]');
    sb.style.background = sharedBoard.bg;
    paintCard($('[data-shared-frame]'), $('[data-shared-frame-title]'), sharedBoard);
    await loadProducts();
    renderItems(sb, sharedBoard, true);
    const cv = $('[data-shared-ink]');
    sizeCanvas(cv);
    drawInk(cv, sharedBoard);
    const counts = {};
    sharedBoard.items.forEach((it) => !isDeco(it.h) && (counts[it.h] = (counts[it.h] || 0) + 1));
    let total = 0;
    let n = 0;
    $('[data-shared-list]').innerHTML = Object.entries(counts)
      .map(([h, q]) => {
        const p = products[h];
        if (!p) return `<li class="dwms__shared-row is-gone">A toy that's no longer available</li>`;
        total += p.price * q;
        n += q;
        return `<li class="dwms__shared-row"><span class="dwms__shared-img${p.cutout ? '' : ' is-photo'}"><img src="${esc(imgOf(p))}" alt="" loading="lazy"></span>
          <span class="dwms__shared-name">${esc(p.name)}${q > 1 ? ` × ${q}` : ''}</span><span class="dwms__shared-price">${money(p.price * q)}</span></li>`;
      })
      .join('');
    $('[data-shared-note]').textContent = n ? `${n} toy${n > 1 ? 's' : ''} on this board · ${money(total)} in total` : '';
    const buy = $('[data-shared-buy]');
    buy.disabled = !n;
    buy.textContent = n ? `Gift these toys · ${money(total)}` : 'These toys are not available right now';
    return true;
  }
  $('[data-shared-buy]').addEventListener('click', (e) =>
    withBusy(e.currentTarget, async () => {
      const n = await addToCart(sharedBoard.items, { 'Gift for mood board': sharedBoard.name, 'Gift mood board link': location.href });
      toast(`${n} toys added to cart 🎁`);
    })
  );
  $('[data-shared-copy]').addEventListener('click', () => {
    const copyB = Object.assign({}, sharedBoard, { id: uid(), updated: Date.now() });
    store.boards.push(copyB);
    persist();
    history.replaceState(null, '', location.pathname + location.search);
    openBoard(copyB.id);
    toast('Saved to your boards ✓');
  });
  $('[data-shared-home]').addEventListener('click', () => {
    history.replaceState(null, '', location.pathname + location.search);
    renderList();
    show('list');
  });

  // ── Start ────────────────────────────────────────────────
  (async () => {
    const m = location.hash.match(/#mb=([\w-]+)/);
    if (m && (await openShared(m[1]))) return;
    renderList();
    show('list');
    await loadProducts();
    renderList();
  })();
})();
